import clsx from 'clsx';
import ExternalLink from '@/components/elements/ExternalLink';

/**
 * A subcomponent of the VideoWayfinder's InnerSection that contains the text
 * part of the section, with a title, content, and optional link.
 */
const ContentBlock = ({
  blockColor,
  videoFirst,
  portraitVideo,
  title,
  content,
  link
}) => {
  return (
    <div
      className={clsx(
        'sm:pt-72',
        blockColor ? `bg-[${blockColor}]` : 'bg-warm-pewter-20',
        portraitVideo
          ? 'flex p-5 sm:pb-15 lg:min-h-[400px] lg:py-5'
          : 'px-4 pt-5 pb-8 lg:p-28',
        {
          'lg:pr-28 lg:pl-20': portraitVideo && videoFirst,
          'lg:pr-20 lg:pl-28': portraitVideo && !videoFirst
        }
      )}
    >
      <div
        className={clsx(
          'mx-auto text-center lg:max-w-full lg:text-left',
          portraitVideo ? 'self-center sm:max-w-[523px]' : 'sm:max-w-[65%]',
          videoFirst ? 'lg:mr-0 lg:ml-28' : 'lg:mr-28 lg:ml-0'
        )}
      >
        <h2 className="h5 sm:h3 mb-4.5">{title}</h2>
        <div
          dangerouslySetInnerHTML={{ __html: content }}
          className={clsx('body-r sm:body-l', {
            'mb-8': !portraitVideo
          })}
        />
        {link.show_link && link.reference[0].url && (
          <ExternalLink
            linkStyling="font-lato button-text block text-lg font-semibold tracking-[1px] text-black underline"
            internalLink={link.reference[0].url}
            linkText={link.label}
          />
        )}
      </div>
    </div>
  );
};

export default ContentBlock;
